module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [(_vm.show_all) ? _c('div', {
    staticClass: "section",
    staticStyle: {
      "margin": "0 1em"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "orders-panel",
    staticStyle: {
      "margin": "0 1em"
    }
  }, _vm._l((_vm.orders), function(order) {
    return _c('div', {
      on: {
        "click": function($event) {
          _vm.setOrder(order)
        }
      }
    }, [_c('div', {
      staticClass: "card card-flat-pad",
      staticStyle: {
        "background": "#ffffff",
        "border-radius": "15px"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('div', [_c('span', {
      staticStyle: {
        "color": "#df4d4d",
        "font-size": "10px"
      }
    }, [_c('u', [_c('b', [_vm._v(_vm._s(order.order_no))])])]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.order_date))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [((order.order_business_agent_type && (order.order_business_agent_type == 20))) ? _c('span', {
      staticStyle: {
        "color": "inherit",
        "font-weight": "bolder"
      }
    }, [_vm._v(_vm._s(order.order_business_agent_name))]) : _c('span', {
      staticStyle: {
        "color": "inherit",
        "font-weight": "bolder"
      }
    }, [_vm._v(_vm._s(order.order_business))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "0.45em"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.formatCurrency_2(order.order_total))), _c('br'), _vm._v(" ")]), _vm._v(" "), (order.order_payment_status_id == 7) ? _c('div', [_c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("*Not Paid")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [((order.order_items.length > 0) && Object.keys(order.order_items[0]).length > 0) ? _c('div', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + order.order_items[0].product_item_group_image,
        "height": "50",
        "width": "50"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(order.order_items.length) + " item(s)")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "0.65em"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-backdrop": "false",
        "data-target": "#ordersModal"
      },
      on: {
        "click": function($event) {
          _vm.setOrder(order)
        }
      }
    }, [_c('span', {
      staticClass: "p-tiny"
    }, [_vm._v("View >>")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.show_single) ? _c('div', {
    staticClass: "section",
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('div', {
    staticClass: "container"
  }), _vm._v(" "), (!_vm.show_products_for_review) ? _c('div', [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "background-color": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "col lg-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "28px",
      "font-weight": "bolder"
    },
    on: {
      "click": _vm.viewOrders
    }
  }, [_vm._v("X")])])]), _vm._v(" "), _c('div', {
    staticClass: "col lg-12"
  }, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.is_new) ? _c('h3', {
    staticClass: "text-align-left margin-bottom-double"
  }, [_vm._v("Thank you. Your order has been received.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flexh-justify-left sm-flexv"
  }, [_c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Order number:")]), _vm._v(" " + _vm._s(_vm.order.order_no))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Date:")]), _vm._v(" " + _vm._s(_vm.order.order_date))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("From:")]), _vm._v(" "), _c('span', [((_vm.order.order_business_agent_type && (_vm.order.order_business_agent_type == 20))) ? _c('a', {
    staticStyle: {
      "color": "inherit",
      "font-weight": "bolder",
      "text-decoration": "underline"
    },
    attrs: {
      "href": '/' + _vm.order.order_business_agent_username
    }
  }, [_vm._v(_vm._s(_vm.order.order_business_agent_name))]) : _c('a', {
    staticStyle: {
      "color": "inherit",
      "font-weight": "bolder",
      "text-decoration": "underline"
    },
    attrs: {
      "href": '/' + _vm.order.order_business_username
    }
  }, [_vm._v(_vm._s(_vm.order.order_business))])])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Payment method: ")]), _vm._v(_vm._s(_vm.order.order_payment_mode_name))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('span', {
    style: ({
      color: _vm.order.order_payment_status_color
    })
  }, [_vm._v(_vm._s(_vm.order.order_payment_status))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.order.order_payment_status_id == 7) ? _c('div', [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "href": '/checkout/re/' + _vm.order.order_no
    }
  }, [_vm._v("Make Payment")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flexh-justify-left sm-flexv",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Order Amount:")]), _vm._v(" ₦" + _vm._s(_vm.order.order_items_total))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Shipping:")]), _vm._v(" ₦" + _vm._s(_vm.order.order_shipping_total))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Total:")]), _vm._v(" ₦" + _vm._s(_vm.order.order_total))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flexh-justify-center sm-flexv",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Delivery Location:")]), _vm._v(" " + _vm._s(_vm.order.order_delivery_city))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Address:")]), _vm._v(" " + _vm._s(_vm.order.order_user_delivery_address))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "flexh-justify-center sm-flexv",
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "1em"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.show_brokers = true
      }
    }
  }, [_vm._v("Broker this Deal?")]), _vm._v(" "), (_vm.show_brokers) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit",
      "text-decoration": "none",
      "font-size": "18px",
      "margin-left": "2em"
    },
    on: {
      "click": function($event) {
        _vm.show_brokers = false;
        _vm.data_processing_message = '';
      }
    }
  }, [_vm._v("X")]) : _vm._e(), _vm._v(" "), (_vm.show_brokers && !(Object.keys(_vm.brokers).length === 0)) ? _c('div', {
    staticClass: "row card"
  }, _vm._l((_vm.brokers), function(broker) {
    return _c('div', {
      staticClass: "card",
      staticStyle: {
        "padding": "1em",
        "margin": "1em",
        "border": "1px solid #1d1d1d"
      }
    }, [_c('div', {
      staticClass: "col-xs-2",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle card-avatar-circle-sm"
    }, [(broker.broker_profile_image && (broker.broker_profile_image != '')) ? _c('img', {
      attrs: {
        "src": broker.broker_profile_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10"
    }, [_c('p', [_vm._v(_vm._s(broker.broker_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Starting Fee: ")]), _vm._v("₦" + _vm._s(broker.broker_starting_fee))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "sp-app-default-color"
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "sp-button-1 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.sendMessageToBroker(broker)
        }
      }
    }, [_vm._v("Request Service")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })) : _vm._e()]), _vm._v(" "), (_vm.order.order_notifications && (_vm.order.order_notifications > 0)) ? _c('div', {
    staticClass: "flexh-justify-center sm-flexv",
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "1em"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.show_order_notifications = true
      }
    }
  }, [_vm._v("Order Notifications"), _c('span', {
    staticStyle: {
      "margin-left": "3px",
      "float": "right"
    }
  }, [_c('sup', [_c('span', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.order.order_notifications))])])])]), _vm._v(" "), (_vm.show_order_notifications) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit",
      "text-decoration": "none",
      "font-size": "18px",
      "margin-left": "2em"
    },
    on: {
      "click": function($event) {
        _vm.show_order_notifications = false;
        _vm.data_processing_message = '';
      }
    }
  }, [_vm._v("X")]) : _vm._e(), _vm._v(" "), (_vm.show_order_notifications) ? _c('div', {
    staticClass: "row card"
  }, [(Object.keys(_vm.order.order_broker_requests).length !== 0) ? _c('div', [_c('h5', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Brokers Requests")]), _vm._v(" "), _vm._l((_vm.order.order_broker_requests), function(broker_rq) {
    return _c('div', {
      staticClass: "card",
      staticStyle: {
        "padding": "1em",
        "margin": "1em",
        "border": "1px solid #1d1d1d"
      }
    }, [_c('div', {
      staticClass: "col-xs-2",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle card-avatar-circle-sm"
    }, [(broker_rq.broker_profile_image && (broker_rq.broker_profile_image != '')) ? _c('img', {
      attrs: {
        "src": broker_rq.broker_profile_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10"
    }, [_c('p', [_vm._v(_vm._s(broker_rq.broker_request_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Broker Fee: ")]), _vm._v("₦" + _vm._s(broker_rq.broker_request_fee))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "sp-app-default-color"
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "sp-button-1 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.show_payment_service = true;
          _vm.broker_request = broker_rq;
          _vm.setBrokerOrderPaymentData();
        }
      }
    }, [_vm._v("PAY")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(_vm._s(_vm.show_empty_fields) + "\r\n                          "), (_vm.show_payment_service && (_vm.broker_request.broker_request_ref == broker_rq.broker_request_ref)) ? _c('div', {
      staticClass: "card col-xs-12"
    }, [(_vm.show_empty_fields && (_vm.broker_request.broker_request_ref == broker_rq.broker_request_ref)) ? _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Please provide these details")]), _vm._v(" "), _c('form', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.user_email),
        expression: "user.user_email"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Email"
      },
      domProps: {
        "value": (_vm.user.user_email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.user.user_email = $event.target.value
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.user_phone),
        expression: "user.user_phone"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "placeholder": "Phone Number"
      },
      domProps: {
        "value": (_vm.user.user_phone)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.user.user_phone = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "sp-button-1 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setBrokerOrderPaymentData();
        }
      }
    }, [_vm._v("SET")])])]) : _c('div', [_c('component-payment-service', {
      attrs: {
        "paymentdata": _vm.broker_request_payment_data
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2) : _vm._e()]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "col lg-12 position-relative",
    staticStyle: {
      "margin-bottom": "5em",
      "margin-top": "2em"
    }
  }, [_c('div', {
    staticClass: "c-shop-order__wrapper sm-overflow-scroll orders-panel"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("Order")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _vm._l((_vm.order.order_items), function(item) {
    return _c('tr', {
      staticStyle: {
        "padding-bottom": "10em !important"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "70%"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_c('b', [_vm._v("ORD NO: ")]), _vm._v(_vm._s(item.order_item_no))]), _c('br'), _vm._v("\r\n                          " + _vm._s(item.product_name) + "\r\n                          "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline",
        "padding-bottom": "1em"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image,
        "height": "50",
        "width": "50"
      }
    }), _c('br'), _c('br')])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.order_item_quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.order_item_total.toFixed(2)))])])
  })], 2)])])]), _vm._v(" "), (_vm.order.order_can_review == 0) ? _c('div', {
    staticClass: "mobile-fix-nav-2"
  }, [_c('p', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.updateOrders(_vm.order, 'received')
      }
    }
  }, [(_vm.order.order_status_id == 18) ? _c('div', {
    staticStyle: {
      "background": "#337ab7",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_vm._v("\r\n            Mark order as received\r\n          ")]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.prepareProductsForReview()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "background": "#e94b4b",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_vm._v("\r\n            Review Products\r\n          ")])])]) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col lg-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "28px",
      "font-weight": "bolder"
    },
    on: {
      "click": function($event) {
        _vm.show_products_for_review = false
      }
    }
  }, [_vm._v("X")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.order.order_items), function(item, idex) {
    return (item.order_item_can_review == 1) ? _c('div', {
      staticClass: "card-flat-pad",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "20%"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image,
        "height": "50",
        "width": "50"
      }
    }), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "80%"
      }
    }, [(_vm.order_item.data_processing_message != '') ? _c('p', {
      key: _vm.componentOrderItemReviewKey,
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.order_item.data_processing_message))]) : _vm._e(), _vm._v(" "), _c('form', {
      staticClass: "sp-form"
    }, [_c('div', {}, [_vm._m(2, true), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.order_item.product_item_review),
        expression: "order_item.product_item_review"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "write a review"
      },
      domProps: {
        "value": (_vm.order_item.product_item_review)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.order_item.product_item_review = $event.target.value
        }
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('b', [_vm._v("Rate Product:")]), _vm._v(" "), _vm._l((_vm.order_item.star_rates), function(star, sdex) {
      return _c('a', {
        staticStyle: {
          "padding": "2px",
          "color": "#ffffff",
          "display": "inline",
          "cursor": "pointer",
          "text-decoration": "none"
        },
        on: {
          "click": function($event) {
            _vm.setRating(sdex, idex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-star rate-stars i-default",
        attrs: {
          "id": sdex + 'STR' + idex
        }
      })])
    })], 2)]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-md",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.submitReview
      }
    }, [_vm._v("submit")])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]) : _vm._e()
  }))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sp-app-default-color"
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "padding": "1.7em",
      "border": "solid 1px",
      "border-radius": "15px",
      "background-color": "#be0a4f"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "o-node a1"
  }, [_c('div', {
    staticClass: "o-node-left"
  }, [_c('div', {
    staticClass: "o-node-left-icon"
  }, [_vm._v("\r\n                          1\r\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "o-node-right"
  }, [_c('p', [_vm._v("Order Placed")])])]), _vm._v(" "), _c('div', {
    staticClass: "o-node a2",
    staticStyle: {
      "background-color": "#d8d50b"
    }
  }, [_c('div', {
    staticClass: "o-node-left"
  }, [_c('div', {
    staticClass: "o-node-left-icon"
  }, [_vm._v("\r\n                        2\r\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "o-node-right"
  }, [_c('p', [_vm._v("Order Confirmed")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Review Product")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba3f65b6"}!./src/pages/Orderpoint/Orders/template.html
// module id = 579
// module chunks = 0